import { toast } from "sonner";
import { Download, RotateCcw, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusChip } from "@/components/app/StatusChip";
import { api, errMsg } from "@/lib/api";
import { HRMS, HRMS_LABEL, download } from "@/lib/fit";

export function HrmsCard({ appId, hrms, canRetry, onChanged }) {
  const retry = async () => { try { await api.post(`/applications/${appId}/hrms/retry`); toast.success("Retrying the sync"); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  const exp = (f) => download(`/applications/${appId}/hire-export?format=${f}`, `hire-${appId.slice(0, 8)}.${f}`).catch((e) => toast.error(errMsg(e)));
  const s = hrms?.status || "pending";
  return (
    <section className="panel flex flex-wrap items-center gap-3 p-4" data-testid="hrms-card">
      <Share2 size={16} className="text-brand" />
      <span className="text-sm font-medium">Hire export</span>
      <span className="inline-flex items-center gap-1" data-testid="hrms-status"><StatusChip status={HRMS[s]} /><span className="text-xs text-ink-secondary">{HRMS_LABEL[s]}</span></span>
      <span className="text-xs text-ink-muted" data-testid="hrms-detail">{s === "synced" ? `Ref ${hrms.external_id || "—"}${hrms.demo ? " (demo)" : ""}` : s === "not_configured" ? "Download the hire record below" : hrms?.error || hrms?.detail || (s === "pending" ? `Attempt ${hrms?.attempts || 0}` : "")}</span>
      <div className="ml-auto flex gap-2">
        {canRetry && s === "failed" && <Button size="sm" variant="outline" onClick={retry} data-testid="hrms-retry-btn"><RotateCcw size={14} /> Retry</Button>}
        <Button size="sm" onClick={() => exp("json")} data-testid="hire-export-json"><Download size={14} /> Export hire (JSON)</Button>
        <Button size="sm" variant="outline" onClick={() => exp("csv")} data-testid="hire-export-csv"><Download size={14} /> Export hire (CSV)</Button>
      </div>
    </section>
  );
}
